/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerSourceAllowName } from './ScreenerSourceAllowName';
import {
    ScreenerSourceAllowNameFromJSON,
    ScreenerSourceAllowNameFromJSONTyped,
    ScreenerSourceAllowNameToJSON,
} from './ScreenerSourceAllowName';

/**
 * 
 * @export
 * @interface FindAllScreenerSourceAllowNamesResponse
 */
export interface FindAllScreenerSourceAllowNamesResponse {
    /**
     * 
     * @type {Array<ScreenerSourceAllowName>}
     * @memberof FindAllScreenerSourceAllowNamesResponse
     */
    data: Array<ScreenerSourceAllowName>;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerSourceAllowNamesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerSourceAllowNamesResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerSourceAllowNamesResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerSourceAllowNamesResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllScreenerSourceAllowNamesResponse interface.
 */
export function instanceOfFindAllScreenerSourceAllowNamesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllScreenerSourceAllowNamesResponseFromJSON(json: any): FindAllScreenerSourceAllowNamesResponse {
    return FindAllScreenerSourceAllowNamesResponseFromJSONTyped(json, false);
}

export function FindAllScreenerSourceAllowNamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSourceAllowNamesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScreenerSourceAllowNameFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllScreenerSourceAllowNamesResponseToJSON(value?: FindAllScreenerSourceAllowNamesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ScreenerSourceAllowNameToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

